
import { shallowEqual, useSelector } from 'react-redux'


const selectoreUI = (state) => state.UI;

export const useUI = () => {   
    const selectedData = useSelector(selectoreUI, shallowEqual)
    return selectedData;
}